import "quill/dist/quill.snow.css";
import ReactQuill from "react-quill";
import { Styled } from "./styles";

type Props = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
};

export const TextAreaWithRichFormatting = (props: Props) => {
  const { value, onChange, placeholder = "Write something..." } = props;

  const modules = {
    toolbar: [
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ list: "ordered" }, { list: "bullet" }],
    ],
  };

  const formats = [
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
  ];

  return (
    <Styled>
      <ReactQuill
        theme="snow"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        modules={modules}
        formats={formats}
      />
    </Styled>
  );
};
